import { cloneElement, type ReactElement, type ReactNode, type Ref } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@components/atoms/Tooltip'
import { useIsTruncated } from '@hooks/useIsTruncated'

export function TruncationTooltip({
  content,
  contentClassName,
  children,
}: {
  content: ReactNode
  contentClassName?: string
  children: ReactElement<{ ref?: Ref<HTMLElement> }>
}) {
  const { ref, isTruncated } = useIsTruncated<HTMLElement>()
  const trigger = cloneElement(children, { ref })

  if (!isTruncated) return trigger

  return (
    <Tooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent className={contentClassName}>{content}</TooltipContent>
    </Tooltip>
  )
}
